import { axiosInstance as request } from '@api/rest.service'
import { downloadFile } from '@lib/generic.utils'

/**
 * @description GET /download/media/{id}
 * @returns {AxiosPromise<any>}
 */
export const DOWNLOAD_MEDIA = id =>
  request.get(`/download/media/${id}`, { responseType: 'arraybuffer' }).then(downloadFile)
